import React from 'react';
import { Button } from 'reactstrap';
import { inject, observer } from 'mobx-react';
import { defineMessages, injectIntl } from 'react-intl';

import { modelOf } from '../../../../prop-types';
import UIStore from '../../../../store/UIStore';
import BarcodeSearchIcon from '../BarcodeSearchIcon';

const messages = defineMessages({
  openBarcodeSearch: {
    id: 'barcodeSearch.openBarcodeSearch',
    defaultMessage: 'Open barcode search',
  },
});

const BarcodeSearchButton = ({ uiStore, intl }) => {
  return (
    <Button
      className="BarcodeSearchButton"
      color=""
      onClick={uiStore.barcodeReaderModal.toggle}
      aria-label={intl.formatMessage(messages.openBarcodeSearch)}
    >
      <BarcodeSearchIcon />
    </Button>
  );
};

BarcodeSearchButton.propTypes = {
  uiStore: modelOf(UIStore).isRequired,
};

export default injectIntl(inject('uiStore')(observer(BarcodeSearchButton)));
